
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 1004","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 561.394 236.159"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 419","fill":"none","d":"M0 0h561.394v236.159H0z"}})]),_c('clipPath',{attrs:{"id":"b"}},[_c('path',{attrs:{"data-name":"Rectangle 418","transform":"translate(46.11)","fill":"none","d":"M0 0h121.741v22.403H0z"}})])]),_c('g',{attrs:{"data-name":"Group 1003","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 7106","d":"M559.394 41.1V10.188H199.272","fill":"none","stroke":"#fff","stroke-width":"4"}}),_c('path',{attrs:{"data-name":"Path 7107","d":"M37.344 10.188H2v155.077","fill":"none","stroke":"#fff","stroke-width":"4"}}),_c('path',{attrs:{"data-name":"Path 7108","d":"M2 163.01v71.149h557.394V163.01","fill":"none","stroke":"#fff","stroke-width":"4"}}),_c('g',{attrs:{"data-name":"Group 1002"}},[_c('g',{attrs:{"data-name":"Group 1001"}},[_c('g',{attrs:{"data-name":"Group 1000"}},[_c('g',{attrs:{"data-name":"Group 999","clip-path":"url(#b)"}},[_c('g',{attrs:{"data-name":"Group 998"}},[_c('g',{attrs:{"data-name":"Group 997","clip-path":"url(#b)"}},[_c('text',{attrs:{"data-name":"SINCE 1997","transform":"translate(46.11 17.981)","fill":"#fff","font-size":"20.554","font-family":"Barlow-MediumItalic, Barlow","font-weight":"500","font-style":"italic"}},[_c('tspan',{attrs:{"x":"0","y":"0","letter-spacing":".109em"}},[_v('SI')]),_c('tspan',{attrs:{"y":"0","letter-spacing":".108em"}},[_v('N')]),_c('tspan',{attrs:{"y":"0","letter-spacing":".109em"}},[_v('CE 199')]),_c('tspan',{attrs:{"y":"0"}},[_v('7')])])])])])])])])])])
          )
        }
      }
    